module.exports = __webpack_public_path__ + "img/xingtu-loading-bg.916ae77a.png";